import React from "react";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { TrustMarquee } from "@/components/site/TrustMarquee";
import { WhyVeda } from "@/components/site/WhyVeda";
import { ValueStack } from "@/components/site/ValueStack";
import { Testimonials } from "@/components/site/Testimonials";
import { HowToUse } from "@/components/site/HowToUse";
import { Faq } from "@/components/site/Faq";
import { Footer } from "@/components/site/Footer";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";

export default function Landing() {
  return (
    <div className="App bg-obsidian">
      <Header />
      <main>
        <Hero />
        <TrustMarquee />
        <WhyVeda />
        <ValueStack />
        <Testimonials />
        <HowToUse />
        <Faq />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
